import { useT } from '../../i18n/useT'

/** The {h}…{/h} markers in hero.title wrap the words that render in the
 * brand color — translators move them with the phrase they emphasize. */
function renderTitle(title: string) {
  const m = title.match(/^(.*)\{h\}(.*)\{\/h\}(.*)$/s)
  if (!m) return title
  return (
    <>
      {m[1]}
      <span className="text-primary">{m[2]}</span>
      {m[3]}
    </>
  )
}

export function HeroSection() {
  const t = useT()
  return (
    <section className="py-12 sm:py-16 text-center">
      <div className="max-w-3xl mx-auto px-4">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-text leading-tight tracking-tight">
          {renderTitle(t('hero.title'))}
        </h1>
        <p className="mt-4 text-base sm:text-lg text-text-secondary max-w-2xl mx-auto leading-relaxed">
          {t('hero.subtitle')}
        </p>
      </div>
    </section>
  )
}
